import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "./style.css";
import store from "src/store";
import api, { useAsync } from "src/api";

const Sitemap = props => {
  const { clientid: clientId } = store("config");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [totalArticles, setTotalArticles] = useState(0);
  const pageSize = 50;
  const urlParams = new URLSearchParams(window.location.search);

  const formatCategories = categories => {
    const mainCategories = categories.map(category => category.split("/")[1]).sort();
    const deduplicatedArray = [...new Set(mainCategories)];
    return deduplicatedArray;
  };
  const useSitemapCategories = useAsync(api.getSitemapCategories);
  const clientCategories = useSitemapCategories({ clientId });
  const useSitemap = useAsync(api.getSitemap, { callOnMount: false });
  const sitemap = useSitemap({
    clientId,
    category: selectedCategory,
    page: currentPage
  });

  useEffect(() => {
    if (selectedCategory) {
      sitemap
        .call({
          clientId,
          category: encodeURIComponent(selectedCategory),
          page: currentPage
        })
        .then(sitemap => {
          if (sitemap.articles && sitemap.totalArticles) {
            setArticles([...sitemap.articles]);
            setTotalArticles(sitemap.totalArticles);
          }
        });
    }
  }, [categories, currentPage, selectedCategory]);

  useEffect(() => {
    clientCategories.call({ clientId }).then(response => {
      const categories = formatCategories(response);
      setCategories([...categories]);
      setSelectedCategory(categories[0]);
    });
    
  }, []);

  const { page, category } = useParams();
  if (page) setCurrentPage(parseInt(page));
  if (category) setSelectedCategory(category);

  const startArticleNo = (currentPage - 1) * pageSize + 1;
  const endArticleNo = Math.min(currentPage * pageSize, totalArticles);
  const totalPages = Math.ceil(totalArticles / pageSize) || 1;

  const handleCategoryClick = category => {
    setSelectedCategory(category);
    let sitemapCategoryUrl = `/sitemap/1/${category}/`;
    if ([...urlParams].length > 0) {
      sitemapCategoryUrl += `?${urlParams}`;
    }
    props.history.push(sitemapCategoryUrl);
  };

  const handlePageChange = page => {
    let pageUrl = props.location.pathname.replace(/\/sitemap\/\d+/, `/sitemap/${page}`);
    if ([...urlParams].length > 0) {
      pageUrl += `?${urlParams}`;
    }
    props.history.push(pageUrl);
  };

  const getArticleUrl = article => {
    let articleUrl = `/_content/article/${article.keyword.replace(/\s+/g, '-')}/`;
    if ([...urlParams].length > 0) {
      // always content page for article pages
      articleUrl += `?${urlParams?.toString().replace(/page=(homepage|search)/, 'page=content')}`;
    }
    return articleUrl;
  };

  const getArticleTitle = article => {
    if (article.content) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(article.content, "text/html");
      const h1 = doc.querySelector("h1");
      return h1 ? h1.innerText : "No Title";
    }
    return "No Title";
  };

  return (
    <div class={styles.sitemapBody} data-af-component="Sitemap">
      <div class={styles.sitemap}>
        <div class={styles.categories}>
          <h2>Sitemap</h2>
          <ul>
            {categories.map(category => (
              <li key={category} onClick={() => handleCategoryClick(category)} class={selectedCategory === category ? styles.active : ""}>
                {category}
              </li>
            ))}
          </ul>
        </div>

        <div class={styles.rightPage}>
          <div class={styles.articlesContainer}>
            {totalArticles > 0 && <div class={styles.showing}>{`${startArticleNo} - ${endArticleNo} of ${totalArticles}`}</div>}
            <h2>{`${totalArticles > 0 ? "Articles in " + selectedCategory : "No Articles Available"}`}</h2>
            <div className={styles.articles}>
              <ul class={styles.articleList}>
                {articles.map(article => (
                  <li key={article.id} className={styles.articleItem}>
                    <div>{new Date(article.createdAt).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</div>
                    <div>
                      <a href={getArticleUrl(article)} className={styles.articleLink}>
                        {getArticleTitle(article)}
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <ul class={styles.pagination}>
            <li onClick={() => (currentPage - 1 > 0 ? handlePageChange(currentPage - 1) : null)}>
              <span class={`${currentPage === 1 ? styles.disabledPage : ""}`}>{`< PREV`}</span>
            </li>

            {[...Array(totalPages).keys()].map(pageNumber => (
              <li key={pageNumber + 1} class={`${styles.pageNumber}`} onClick={() => handlePageChange(pageNumber + 1)}>
                <span class={`${currentPage === pageNumber + 1 ? styles.activePage : ""}`}>{pageNumber + 1}</span>
              </li>
            ))}
            <li onClick={() => (currentPage + 1 <= totalPages ? handlePageChange(currentPage + 1) : null)}>
              <span class={`${currentPage === totalPages ? styles.disabledPage : ""}`}>{`NEXT >`}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
